window.addEventListener('load', () => {
  const cardholderNameInput = document.querySelector('.card-holder-name');
  const cpCardCvv = document.querySelector('.cvv');
  const cardNumberInput = document.querySelector('.card-number');
  const expDateInput = document.querySelector('.exp-date');
  const cvvInput = document.querySelector('.cvv-input');
  const cardCvvInput = document.querySelector('.cvv-card-input');
  const cpCardName = document.querySelector('.cp-name');
  const cardHolderHiddenInput = document.querySelector(
    '.card-holder-hidden-name',
  );
  const cardRadioInput = document.querySelectorAll('.card-radio');
  const cardIdInput = document.querySelector('.card-id-input');
  const cardSubmit = document.querySelector('.card-submit');
  const newCardRadioInput = document.querySelector('.new-card-radio');
  const cpCardNumber = document.querySelector('.cp-card-number');
  const cpCardExpDateMonth = document.querySelector('.exp-date-month');
  const cpCardExpDateYear = document.querySelector('.exp-date-year');
  const saveCardInput = document.querySelector('.save-card');
  const cpErrorsList = document.querySelector('.cp-errors');
  const cvvInputText = document.querySelector('.cvv-input-text');

  if (cardholderNameInput) {
    cardholderNameInput.addEventListener('input', (e) => {
      cardholderNameInput.value = e.target.value.replace(/[^a-zA-Z -]/g, '');

      cpCardName.value = e.target.value.replace(/[^a-zA-Z -]/g, '');
      cardHolderHiddenInput.value = e.target.value.replace(/[^a-zA-Z -]/g, '');
    });
  }

  if (cardCvvInput) {
    cardCvvInput.addEventListener('input', (e) => {
      cpCardCvv.value = e.target.value;
    });
  }

  if (cardRadioInput) {
    [].forEach.call(cardRadioInput, (input) => {
      input.addEventListener('click', () => {
        const {value} = input;
        const {name} = input.dataset;

        if (cardholderNameInput && cardholderNameInput.value) {
          cardholderNameInput.value = '';
        }

        if (cardNumberInput && cardNumberInput.value) {
          cardNumberInput.value = '';
        }

        if (expDateInput && expDateInput.value) {
          expDateInput.value = '';
        }

        if (cvvInput && cvvInput.value) {
          cvvInput.value = '';
        }

        if (cardIdInput) {
          cardIdInput.value = value;
        }

        if (saveCardInput && saveCardInput.checked) {
          saveCardInput.checked = false;
        }

        if (cardHolderHiddenInput) {
          cardHolderHiddenInput.value = name;
        }

        if (cardSubmit && cardSubmit.classList.contains('disabled')) {
          cardSubmit.classList.remove('disabled');
        }
      });
    });
  }

  if (newCardRadioInput) {
    newCardRadioInput.addEventListener('click', () => {
      cpErrorsList.innerHTML = '';

      cpCardNumber.value = '';
      cpCardExpDateMonth.value = '';
      cpCardExpDateYear.value = '';
      cpCardCvv.value = '';
      cpCardName.value = '';
      cardCvvInput.value = '';
      cardHolderHiddenInput.value = '';
      cardIdInput.value = '';

      if (cardSubmit && cardSubmit.classList.contains('disabled')) {
        cardSubmit.classList.remove('disabled');
      }
    });
  }

  const cardMask = (input) => {
    const matrix = '____ ____ ____ ____ ____ ____ _';
    let i = 0;
    const def = matrix.replace(/\D/g, '');
    let val = input.value.replace(/\D/g, '');

    if (def.length >= val.length) {
      val = def;
    }

    input.value = matrix.replace(/./g, (a) => {
      return /[_\d]/.test(a) && i < val.length
        ? val.charAt(i++)
        : i >= val.length
          ? ''
          : a;
    });

    if (input.type == 'blur') {
      if (input.value.length == 2) {
        input.value = '';
      }
    }

    cpCardNumber.value = val;
  };

  const expDateMask = (input) => {
    const matrix = '__/__';
    let i = 0;
    const def = matrix.replace(/\D/g, '');
    let val = input.value.replace(/\D/g, '');

    if (def.length >= val.length) {
      val = def;
    }

    input.value = matrix.replace(/./g, (a) => {
      return /[_\d]/.test(a) && i < val.length
        ? val.charAt(i++)
        : i >= val.length
          ? ''
          : a;
    });

    if (input.type == 'blur') {
      if (input.value.length == 2) {
        input.value = '';
      }
    }

    const expDateMonthYear = input.value.split('/');

    cpCardExpDateMonth.value = expDateMonthYear[0];
    cpCardExpDateYear.value = expDateMonthYear[1];
  };

  if (cardNumberInput) {
    cardNumberInput.addEventListener('input', () => {
      cardMask(cardNumberInput);
    });

    cardNumberInput.addEventListener('focus', () => {
      cardMask(cardNumberInput);
    });

    cardNumberInput.addEventListener('blur', () => {
      cardMask(cardNumberInput);
    });
  }

  if (expDateInput) {
    expDateInput.addEventListener('focus', () => {
      expDateMask(expDateInput);
    });

    expDateInput.addEventListener('blur', () => {
      expDateMask(expDateInput);
    });

    expDateInput.addEventListener('input', () => {
      expDateMask(expDateInput);
    });
  }

  if (cvvInput) {
    cvvInput.addEventListener('input', (e) => {
      const value = e.target.value.replace(/[^0-9]/g, '');
      cvvInput.value = value;
      cpCardCvv.value = value;

      setTimeout(() => {
        if (cvvInputText) {
          cvvInputText.innerHTML = cvvInput.value.replace(/[^\*]/g, '*');
        }
      }, 200);
    });
  }
});

const CreatePayment = async ({
  orderId,
  userPhone,
  userEmail,
  userId,
  amount,
  redirectUrlForSuccess = `${window.location.origin}/profile/orders/${orderId}`,
  redirectUrlForFail = `${window.location.origin}/profile/orders/${orderId}`,
}) => {

  const payments = new cp.CloudPayments({
    language: 'ru-RU',
    email: '',
    applePaySupport: false,
    googlePaySupport: true,
    yandexPaySupport: true,
    tinkoffInstallmentSupport: true,
  });

  const formattedAmount = amount ? parseInt(amount) / 100 : 0;

  if (!formattedAmount) return;

  const redirectOptions = {
    onSuccess: redirectUrlForSuccess,
    onFail: redirectUrlForFail,
  }

  const paymentData = {
    publicId: window.cpPublicKey,
    amount: formattedAmount,
    description: 'Оплата заказа',
    currency: "RUB",
    accountId: userId,
    invoiceId: orderId,
    email: userEmail,
    requireEmail: true,
    autoClose: 3,
    payer: {
      phone: userPhone,
    },
    configuration: {
      common: {
        successRedirectUrl: redirectUrlForSuccess,
        failRedirectUrl: redirectUrlForFail,
      }
    },
  };

  payments.pay('auth', paymentData, redirectOptions);
};

export default CreatePayment;
